import { gql } from "@apollo/react-hooks";

export const SIGN_UP_USER = gql`
  mutation signupUser(
    $username: String!
    $email: String
    $wallet_address: String!
    $password: String
  ) {
    signupUser(
      userInput: {
        username: $username
        email: $email
        wallet_address: $wallet_address
        password: $password
      }
    ) {
      id
      uid
      username
      wallet_address
      email
      balance
      expirience
      avatar_url
      created_at
      avatar_generated
      has_password
      email_activated
      is_staff
      referral_code
      statistics {
        total {
          total
          games_won
          games_lose
          profits
          wagered
          max_profit
        }
        blackjack {
          total
          games_won
          games_lose
          profits
          wagered
          max_profit
        }
        coinflip {
          total
          games_won
          games_lose
          profits
          wagered
          max_profit
        }
        jackpot {
          total
          games_won
          games_lose
          profits
          wagered
          max_profit
        }
      }
      policies {
        key
        value
        expire_at
      }
      social_media {
        facebook {
          _
        }
        twitch {
          _
        }
        twitter {
          _
        }
        youtube {
          _
        }
        discord {
          _
        }
      }
    }
  }
`;

export const LOGIN_USER_WALLET = gql`
  mutation loginUserWallet(
    $wallet_address: String!
    $message: String!
    $signature: String!
  ) {
    loginUserWallet(
      userLogin: {
        wallet_address: $wallet_address
        message: $message
        signature: $signature
      }
    ) {
      token
    }
  }
`;

export const CREATE_COINFLIP_GAME = gql`
  mutation createCoinflipGame(
    $userId: ID!
    $is_private: Boolean!
    $userPick: result!
    $stake: BigInt!
  ) {
    createCoinflipGame(
      coinflipInput: {
        userId: $userId
        is_private: $is_private
        userPick: $userPick
        stake: $stake
      }
    ) {
      game_metadata {
        status
        max_players
        creator {
          username
          id
          is_staff
          uid
          avatar_url
          expirience
        }
        started_at
        created_at
        ended_at
        status
        is_private
      }
      uid
      tails_user {
        uid
        username
        is_staff
        avatar_url
        id
        expirience
      }
      heads_user {
        uid
        username
        is_staff
        avatar_url
        id
        expirience
      }
      stake
      reward
      roll
      result
      ticket_id
      ticket_hash
      ticket_verify_url
    }
  }
`;

export const JOIN_COINFLIP_GAME = gql`
  mutation joinCoinflipGame($gameUid: String!, $userId: ID!) {
    joinCoinflipGame(
      joinCoinflipInput: { gameUid: $gameUid, userId: $userId }
    ) {
      game_metadata {
        creator {
          uid
          username
          is_staff
          avatar_url
          id
          expirience
        }
        created_at
        status
        started_at
        ended_at
        max_players
        is_private
      }
      uid
      tails_user {
        uid
        username
        is_staff
        avatar_url
        id
        expirience
      }
      heads_user {
        uid
        username
        is_staff
        avatar_url
        id
        expirience
      }
      stake
      reward
      roll
      result
      ticket_id
      ticket_hash
      ticket_verify_url
    }
  }
`;

export const PICK_A_WINNER = gql`
  mutation pickAWinnerCoinflipGame($gameUid: String!, $userId: ID!) {
    pickAWinnerCoinflipGame(gameUid: $gameUid, userId: $userId) {
      game_metadata {
        creator {
          uid
          username
          is_staff
          avatar_url
          id
          expirience
        }
        created_at
        status
        started_at
        ended_at
        max_players
        is_private
      }
      uid
      tails_user {
        uid
        username
        is_staff
        avatar_url
        id
        expirience
      }
      heads_user {
        uid
        username
        is_staff
        avatar_url
        id
        expirience
      }
      stake
      reward
      roll
      result
      ticket_id
      ticket_hash
      ticket_verify_url
    }
  }
`;

export const CANCEL_COINFLIP_GAME = gql`
  mutation ($userId: ID!, $gameUid: String!) {
    deleteCoinflipGame(input: { userId: $userId, gameUid: $gameUid }) {
      successful
    }
  }
`;

export const JOIN_JACKPOT_GAME = gql`
  mutation ($userId: ID!, $gameUid: String!, $stake: BigInt!) {
    joinJackpotGame(
      JoinJackpotGameInput: {
        userId: $userId
        gameUid: $gameUid
        stake: $stake
      }
    ) {
      game_metadata {
        creator {
          id
          username
          is_staff
          avatar_url
          expirience
        }
      }
      uid
      players_joined
      total_stakes
      bank
      roll
      roll_stake
      reward
      ticket_id
      ticket_hash
      ticket_verify_url
      players {
        user {
          id
          username
          is_staff
          avatar_url
          expirience
        }
        total_stake
        total_stakes
      }
      stakes {
        stake
        userId
        timestamp
      }
      winner_id
    }
  }
`;

export const BET_JACKPOT_GAME = gql`
  mutation ($userId: ID!, $gameUid: String!, $stake: BigInt!) {
    betJackPotGame(
      betJackPotGameInput: { userId: $userId, gameUid: $gameUid, stake: $stake }
    ) {
      game_metadata {
        creator {
          id
          username
          is_staff
          avatar_url
          expirience
        }
        max_players
        is_private
        created_at
        started_at
        ended_at
        status
      }
      uid
      players_joined
      total_stakes
      bank
      roll
      roll_stake
      reward
      ticket_id
      ticket_hash
      ticket_verify_url
      players {
        user {
          id
          username
          is_staff
          avatar_url
          expirience
        }
        total_stake
        total_stakes
      }
      stakes {
        stake
        userId
        timestamp
      }
      winner_id
    }
  }
`;

export const JOIN_BLACKJACK_GAME = gql`
  mutation ($userId: ID!, $uid: String!) {
    game: joinBlakcjackGame(input: { userId: $userId, uid: $uid }) {
      game_metadata {
        status
        max_players
        creator {
          username
          id
          is_staff
          uid
          avatar_url
          expirience
        }
        started_at
        created_at
        ended_at
        status
      }
      uid
      players {
        user {
          username
          uid
          id
          is_staff
          expirience
          avatar_url
        }
        points
        ready_to_play
        status
        winner
        reward
        cards {
          type
          order
        }
        tickets {
          userId
          ticket_id
          ticket_hash
          ticket_verify_url
          order
          roll
          card_index
          activated_at
        }
        joined_at
      }
      cost
      prepay_rate
      prepay_amount
      referral_stakes_periods
      referral_wagered_in_period
      cards_order
      ticket_id
      ticket_hash
      ticket_verify_url
      secret_hash
    }
  }
`;

export const CREATE_BLACKJACK_GAME = gql`
  mutation (
    $userId: ID!
    $cost: BigInt!
    $prepay_rate: Float
    $max_players: Int!
    $is_private: Boolean!
    $prepay_amount: BigInt
    $referral_stakes_periods: BigInt
    $referral_wagered_in_period: BigInt
  ) {
    game: createBlackjackGame(
      input: {
        userId: $userId
        cost: $cost
        prepay_rate: $prepay_rate
        max_players: $max_players
        is_private: $is_private
        prepay_amount: $prepay_amount
        referral_stakes_periods: $referral_stakes_periods
        referral_wagered_in_period: $referral_wagered_in_period
      }
    ) {
      game_metadata {
        status
        max_players
        creator {
          username
          id
          is_staff
          uid
          avatar_url
          expirience
        }
        started_at
        created_at
        ended_at
        status
      }
      uid
      players {
        user {
          username
          uid
          id
          is_staff
          expirience
          avatar_url
        }
        points
        ready_to_play
        status
        winner
        reward
        cards {
          type
          order
        }
        tickets {
          userId
          ticket_id
          ticket_hash
          ticket_verify_url
          order
          roll
          card_index
          activated_at
        }
        joined_at
      }
      cost
      prepay_rate
      prepay_amount
      referral_stakes_periods
      referral_wagered_in_period
      cards_order
      ticket_id
      ticket_hash
      ticket_verify_url
      secret_hash
    }
  }
`;

export const LEAVE_BLACKJACK_GAME = gql`
  mutation ($userId: ID!, $uid: String!) {
    leaveBlackjackGame(input: { userId: $userId, uid: $uid }) {
      successful
    }
  }
`;

export const READY_BLACKJACK_GAME = gql`
  mutation ($userId: ID!, $uid: String!) {
    readyToPlayBlackjackGame(input: { userId: $userId, uid: $uid }) {
      successful
    }
  }
`;

export const HIT_CARD_BLACKJACK_GAME = gql`
  mutation ($userId: ID!, $uid: String!) {
    user: hitCardInBlackjackGame(input: { userId: $userId, uid: $uid }) {
      card {
        type
        order
      }
      ticket {
        userId
        ticket_id
        ticket_hash
        ticket_verify_url
        order
        roll
        card_index
        activated_at
      }
    }
  }
`;

export const STAY_BLACKJACK_GAME = gql`
  mutation ($userId: ID!, $uid: String!) {
    stayInBlackajackGame(input: { userId: $userId, uid: $uid }) {
      successful
    }
  }
`;

export const ADD_USER_DEPOSIT = gql`
  mutation addUserDeposit($userId: ID!, $signature: String!) {
    addUserDeposit(userId: $userId, transaction: { signature: $signature }) {
      wallet_address
      ammount
      signature
      solscan_url
      timestamp
      points_equivalent
    }
  }
`;

export const ADD_USER_WITHDRAWAL = gql`
  mutation addUserWithdrawal($userId: ID!, $ammount: BigInt!) {
    addUserWithdrawal(userId: $userId, transaction: { ammount: $ammount }) {
      wallet_address
      ammount
      points_equivalent
      signature
      solscan_url
      timestamp
    }
  }
`;

export const SEND_MESSAGE = gql`
  mutation ($userId: ID!, $message: String!, $reply: String) {
    sendMessage(input: { userId: $userId, message: $message, reply: $reply }) {
      id
      user {
        id
        uid
        username
        is_staff
        avatar_url
        expirience
      }
      message
      reply {
        user {
          id
          uid
          username
          is_staff
          avatar_url
          expirience
        }
        message
      }
      likes
    }
  }
`;

export const LIKE_MESSAGE = gql`
  mutation ($userId: ID!, $mId: String!) {
    likeMessage(input: { userId: $userId, mId: $mId }) {
      successful
    }
  }
`;

export const UNLIKE_MESSAGE = gql`
  mutation ($userId: ID!, $mId: String!) {
    unlikeMessage(input: { userId: $userId, mId: $mId }) {
      successful
    }
  }
`;

export const GET_MESSAGES = gql`
  query ($limit: Int) {
    getMessages(limit: $limit) {
      messages {
        id
        user {
          id
          uid
          username
          is_staff
          avatar_url
          expirience
        }
        message
        reply {
          user {
            uid
            username
            is_staff
            avatar_url
            expirience
          }
          message
        }
        likes
      }
    }
  }
`;
